import { createSelector } from 'reselect';
import { ITenderMenusState, ITenderMenuItem } from './types';

export const selectTenderMenus = (state: ITenderMenusState) => state.tenderMenus;

export const selectIndexedTenders = createSelector(selectTenderMenus, (tenderMenus) =>
  tenderMenus.reduce((indexed: { [key: string]: ITenderMenuItem }, tenderMenu: ITenderMenuItem) => {
    if (tenderMenu.id) {
      indexed[tenderMenu.id] = tenderMenu;
    }
    return indexed;
  }, {})
);
